"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortableExperience = exports.PermissionItem = void 0;
const validation_1 = require("../../validation");
/** @alpha */
var PermissionItem;
(function (PermissionItem) {
    PermissionItem["PI_ALLOW"] = "allow";
    PermissionItem["PI_KILL"] = "kill";
    PermissionItem["PI_HIDE_UI"] = "hideUi";
})(PermissionItem = exports.PermissionItem || (exports.PermissionItem = {}));
/** @alpha */
var PortableExperience;
(function (PortableExperience) {
    PortableExperience.schema = {
        type: 'object',
        properties: {
            permission: {
                type: 'string',
                enum: Object.values(PermissionItem),
                nullable: true,
                errorMessage: `permission should be one of: ${Object.values(PermissionItem).join(', ')}`
            }
        }
    };
    PortableExperience.validate = (0, validation_1.generateLazyValidator)(PortableExperience.schema);
})(PortableExperience = exports.PortableExperience || (exports.PortableExperience = {}));
//# sourceMappingURL=portable-experience.js.map